export default __webpack_public_path__ + "static/media/InfoPhoneLoginPageBanner.df4077b0.png";